import { crv, cva } from '@/styled-system/css';

export const carouselScrollContainerStyles = cva({
  base: {
    display: 'flex',
    listStyle: 'none',
    margin: 0,
    flexWrap: 'nowrap',
    overflowX: 'auto',
    scrollbarWidth: 'none',
    scrollBehavior: 'smooth',
    _scrollbar: {
      display: 'none',
    },
    paddingBlockStart: 'Carousel.SlideArray.padding.top',
    paddingBlockEnd: 'Carousel.SlideArray.padding.bottom',
    _motionReduce: {
      scrollBehavior: 'auto',
    },
  },
  variants: {
    ...crv('enableSnap', {
      true: {
        scrollSnapType: 'x mandatory',
      },
      false: {
        scrollSnapType: 'none',
      },
    }),
    ...crv('scrollOffset', {
      none: {
        paddingInline: 'Carousel.SlideArray.scrollOffset.none.padding-horz',
        scrollPaddingInline: 'Carousel.SlideArray.scrollOffset.none.padding-horz',
      },
      xs: {
        paddingInline: 'Carousel.SlideArray.scrollOffset.xs.padding-horz',
        scrollPaddingInline: 'Carousel.SlideArray.scrollOffset.xs.padding-horz',
      },
      sm: {
        paddingInline: 'Carousel.SlideArray.scrollOffset.sm.padding-horz',
        scrollPaddingInline: 'Carousel.SlideArray.scrollOffset.sm.padding-horz',
      },
      md: {
        paddingInline: 'Carousel.SlideArray.scrollOffset.md.padding-horz',
        scrollPaddingInline: 'Carousel.SlideArray.scrollOffset.md.padding-horz',
      },
      lg: {
        paddingInline: 'Carousel.SlideArray.scrollOffset.lg.padding-horz',
        scrollPaddingInline: 'Carousel.SlideArray.scrollOffset.lg.padding-horz',
      },
      xl: {
        paddingInline: 'Carousel.SlideArray.scrollOffset.xl.padding-horz',
        scrollPaddingInline: 'Carousel.SlideArray.scrollOffset.xl.padding-horz',
      },
    }),
    ...crv('slideGap', {
      xxs: { gap: 'Carousel.SlideArray.slideGap.xxs' },
      xs: { gap: 'Carousel.SlideArray.slideGap.xs' },
      sm: { gap: 'Carousel.SlideArray.slideGap.sm' },
      md: { gap: 'Carousel.SlideArray.slideGap.md' },
      lg: { gap: 'Carousel.SlideArray.slideGap.lg' },
      xl: { gap: 'Carousel.SlideArray.slideGap.xl' },
    }),
  },
});
